import TuneIcon from '@mui/icons-material/Tune';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ListItem } from '../../../sic-lib/types/Lists';
import DrawerListViewOptionsRaw from './DrawerListViewOptionsRaw/DrawerListViewOptionsRaw';

const useStyles = makeStyles()({
    button: {
        padding: '10px',
    },
});

interface Props {
    list: ListItem;
}

export default function DrawerListViewOptions({ list }: Props) {
    const { classes } = useStyles();

    const [drawerId] = React.useState<string>('drawer_list_view_options');

    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <React.Fragment>
            <Tooltip title="Column options">
                <IconButton
                    aria-haspopup={true}
                    aria-controls={drawerId}
                    aria-expanded={isOpen}
                    onClick={handleOpen}
                    className={classes.button}
                    size="large"
                >
                    <TuneIcon />
                </IconButton>
            </Tooltip>
            <DrawerListViewOptionsRaw
                drawerId={drawerId}
                isOpen={isOpen}
                list={list}
                onCloseHandler={handleClose}
            />
        </React.Fragment>
    );
}
